var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { BigNumber } from "bignumber.js";
import { getEnv } from "@ledgerhq/live-env";
import network from "@ledgerhq/live-network/network";
import { isLedgerGasTracker } from "./types";
import { GasTrackerDoesNotSupportEIP1559, LedgerGasTrackerUsedIncorrectly, NoGasTrackerFound, } from "../../errors";
// FIXME: how to know if a Ledger gasTracker supports EIP1559?
// Shouldn't this be a dynamic / remote config? For example if there is an
// update of the explorer backend to support EIP1559, we should be able to
// update this config without having to release a new version of the app?
const explorerIdGasTrackerMap = new Map([
    ["avax", { compatibilty: { eip1559: false } }],
    ["bnb", { compatibilty: { eip1559: false } }],
    ["eth", { compatibilty: { eip1559: true } }],
    ["etc", { compatibilty: { eip1559: false } }],
    ["matic", { compatibilty: { eip1559: true } }],
    ["eth_ropsten", { compatibilty: { eip1559: true } }],
    ["eth_goerli", { compatibilty: { eip1559: true } }],
]);
export const getGasOptions = ({ currency, options, }) => __awaiter(void 0, void 0, void 0, function* () {
    const { gasTracker } = currency.ethereumLikeInfo || /* istanbul ignore next */ {};
    if (!isLedgerGasTracker(gasTracker)) {
        throw new LedgerGasTrackerUsedIncorrectly();
    }
    const gasTrackerConfig = explorerIdGasTrackerMap.get(gasTracker.explorerId);
    if (!gasTrackerConfig) {
        throw new NoGasTrackerFound(`No gas tracker found for ${currency.id}`);
    }
    const { useEIP1559 = false } = options || /* istanbul ignore next */ {};
    if (useEIP1559 && !gasTrackerConfig.compatibilty.eip1559) {
        throw new GasTrackerDoesNotSupportEIP1559(`Gas tracker does not support EIP1559 for ${currency.id}`);
    }
    const { low, medium, high, next_base } = yield network({
        method: "GET",
        url: `${getEnv("EXPLORER")}/blockchain/v4/${gasTracker.explorerId}/gastracker/barometer${useEIP1559 ? "?display=eip1559" : ""}`,
    }).then(({ data }) => ({
        low: new BigNumber(data.low),
        medium: new BigNumber(data.medium),
        high: new BigNumber(data.high),
        next_base: new BigNumber(data.next_base),
    }));
    const EIP1559_BASE_FEE_MULTIPLIER = getEnv("EIP1559_BASE_FEE_MULTIPLIER");
    if (useEIP1559) {
        return {
            slow: {
                maxFeePerGas: next_base.times(EIP1559_BASE_FEE_MULTIPLIER).plus(low),
                maxPriorityFeePerGas: low,
                gasPrice: null,
                nextBaseFee: next_base,
            },
            medium: {
                maxFeePerGas: next_base.times(EIP1559_BASE_FEE_MULTIPLIER).plus(medium),
                maxPriorityFeePerGas: medium,
                gasPrice: null,
                nextBaseFee: next_base,
            },
            fast: {
                maxFeePerGas: next_base.times(EIP1559_BASE_FEE_MULTIPLIER).plus(high),
                maxPriorityFeePerGas: high,
                gasPrice: null,
                nextBaseFee: next_base,
            },
        };
    }
    return {
        slow: {
            gasPrice: low,
            maxFeePerGas: null,
            maxPriorityFeePerGas: null,
            nextBaseFee: null,
        },
        medium: {
            gasPrice: medium,
            maxFeePerGas: null,
            maxPriorityFeePerGas: null,
            nextBaseFee: null,
        },
        fast: {
            gasPrice: high,
            maxFeePerGas: null,
            maxPriorityFeePerGas: null,
            nextBaseFee: null,
        },
    };
});
const gasTracker = {
    getGasOptions,
};
export default gasTracker;
//# sourceMappingURL=ledger.js.map